import {observer} from 'mobx-react-lite';
import React from 'react';
import moment from 'moment';
import { InfoWrapper, FileName, FileUploadWrapper, IconStyled, Info, Status, TrashIconWrapper } from 'src/components/Uploader/Uploader.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';

interface PropsType {
    fileName: string,
    uploadedAt: string,
    onReplace: (event: React.SyntheticEvent) => Promise<void>,
    onRemove: () => void
}

export const FileUploaded = observer((props: PropsType) => {

    const {fileName, uploadedAt, onReplace, onRemove} = props;
    const dateString = moment(parseInt(uploadedAt, 10)).format('hh:mma, Do MMMM YYYY');

    return (
        <FileUploadWrapper>
            <InfoWrapper>
                <IconStyled name='checkmark' />
                <Info>
                    <FileName>{fileName}</FileName>
                    <Status>Uploaded {dateString}</Status>
                </Info>
            </InfoWrapper>
            <ButtonsWrapper>
                <Button version='secondary' size='small' onClick={onReplace}>Replace</Button>
                <TrashIconWrapper onClick={onRemove} />
            </ButtonsWrapper>
        </FileUploadWrapper>
    );

});


